import { GettingStarted } from '../../widgets/getting-started';

export const InitialPage = () => {
  return <GettingStarted />;
};
